import styled from 'styled-components';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton';

export const Button = styled(StyledButton)`
    width: 100%;
    min-width: auto;
`;

export const Buttons = styled.div`
    display: flex;
    width: 100%;
    justify-content: flex-start;
    align-items: center;
    margin-top: 15px;
    @media(max-width: 640px) {
        width: 100%;
        flex-direction: column;
    }
`;

export const ButtonsItem = styled.div`
    display: block;
    width: 219px;
    &:nth-child(1) {
        margin-right: 20px;
    }
    @media(max-width: 640px) {
        width: 100%;
        &:nth-child(2) {
            margin-bottom: 14px;
        }
    }
`;
